import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { ConvenienceFee } from './ConvenienceFee'

const Wallet = types.model('Wallet', {
  id: types.identifier,
  mobile: types.optional(types.number, 0),
  name: types.optional(types.string, ''),
  uuid: types.optional(types.string, ''),
  jiocardnum: types.optional(types.string, ''),
  seed: types.optional(types.string, ''),
  walletUID: types.optional(types.string, ''),
  rank: types.optional(types.number, 0),
  isPopular: types.optional(types.boolean, false),
  status: types.optional(types.string, ''),
  trackerid: types.optional(types.string, ''),
  balance: types.optional(types.string, ''),
  type: types.optional(types.string, ''), // Jio Money Account type
  ovdPresent: types.optional(types.boolean, false),
  logo: types.optional(types.string, ''),
  ovdNumber: types.optional(types.string, ''),
  ovdType: types.optional(types.string, ''),
  instrId: types.optional(types.string, ''),
  convenienceFee: types.array(ConvenienceFee),
  paymentType: types.optional(types.string, 'Wallet'),
})

export type WalletType = Instance<typeof Wallet>
export { Wallet }
